import type {ReactElement} from 'react';
import {useState} from 'react';
import {CostTag} from '@Components/cost-tag';
import {SourceTag} from '@Components/source-tag';
import {isStockItemPredominantlyWhite} from '@Libraries/pmw-stock-media-library';
import type {GridMediaItemStorage, GridMediaItemTag} from '../grid-media-item';
import {GridMediaItem, GridMediaItemTagType} from '../grid-media-item';
import type {GRID_ITEM_TYPE, GridItemProps} from '../grid-item';
import styles from './grid-stock-image-item.module.scss';

export interface GridStockImageItemStorage extends GridMediaItemStorage {
  type: GRID_ITEM_TYPE.STOCK_IMAGE;
  thumbSrc: string;
  source: string;
  data: Record<string, any>;
}

export interface GridAiImageItemStorage extends GridStockImageItemStorage {
  highResSrc: string;
  bottomContent?: ReactElement<any>;
}

export type GridStockImageItemBackEndData = Record<string, any>;

interface GridStockImageItemProps extends GridItemProps {
  thumbSrc: string;
  paddedThumb?: boolean;
  isLoading?: boolean;
  tag?: GridMediaItemTag;
  bottomContent?: ReactElement<any>;
}

export function GridStockImageItem({...props}: GridStockImageItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [hasGrayBackground, setHasGrayBackground] = useState(false);

  const getTag = (): ReactElement<any> => {
    return (
      <div className={`${styles.tagContainer} _full-width _full-height`}>
        {props.tag?.type === GridMediaItemTagType.COST ? (
          <CostTag containerStyle={props.tag.containerStyle} textStyle={props.tag.textStyle} icon={props.tag.icon} price={props.tag.price} />
        ) : (
          <SourceTag containerStyle={props.tag?.containerStyle} contentStyle={props.tag?.iconStyle} />
        )}
      </div>
    );
  };

  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      hasGrayBackground={hasGrayBackground}
      thumb={
        <div>
          <img
            onLoad={(): void => {
              setIsImageLoaded(true);
              void isStockItemPredominantlyWhite(props.thumbSrc).then(setHasGrayBackground);
            }}
            src={props.thumbSrc}
            className={`radius-12 ${styles.thumb}`}
            alt={window.i18next.t('pmwjs_image')}
            draggable="false"
            loading="lazy"
            onContextMenu={(e): void => {
              e.preventDefault();
            }}
          />
          {props.tag ? getTag() : null}
        </div>
      }
    />
  );
}
